import axios from 'axios'
import CryptoJS from 'crypto-js';
class ApiServices {
    getParsedUser() {
        try {
            const encrypted = localStorage.getItem('userKey');
            if (!encrypted) return null;
            const bytes = CryptoJS.AES.decrypt(encrypted, process.env.REACT_APP_SECERET_KEY);
            const decrypted = bytes.toString(CryptoJS.enc.Utf8);
            if (!decrypted) return null;
            return JSON.parse(decrypted);
        } catch (error) {
            return null;
        }
    }

    buildHeaders(apiKey, appVersion) {
        const userInfo = this.getParsedUser();
        const accessToken = userInfo?.stsTokenManager?.accessToken || userInfo?.accessToken || '';
        const instanceId = userInfo?.uid || '';
        const activeProfileId = localStorage.getItem('activeProfileId') || '';
        const headers = {
            apikey: apiKey,
            appversion: appVersion
        };

        if (accessToken) headers.authorization = accessToken;
        if (instanceId) headers.instanceid = instanceId;
        if (activeProfileId) headers['x-profile-id'] = activeProfileId;

        return { headers };
    }

    getHeader() {
        return this.buildHeaders(process.env.REACT_APP_API_KEY, process.env.REACT_APP_VERSION);
    }
    callGetAPI(url) {
        const headers = this.getHeader();
        return new Promise((resolve, reject) => {
            if (!headers.headers.authorization) {          
                //url = url.split("/web").join("/tv")                
            }
            axios.get(process.env.REACT_APP_API_URL + url, headers).then(response => {
                resolve(response)
            }).catch(error => {
                // alert("ERR::" + url + "::" + error.message)
                reject(error)
            })
        });
    }
    callDeleteAPI(url, data = null) {
        const headers = this.getHeader();
        const requestConfig = data ? { ...headers, data } : headers;
        return new Promise((resolve, reject) => {
            axios.delete(process.env.REACT_APP_API_URL + url, requestConfig).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }
    MailGetAPI(url) {
        const headers = this.getHeader();
        return new Promise((resolve, reject) => {
            axios.get('http://35.174.153.53/api/v1/course?page=1&limit=7', headers).then(response => {
                resolve(response)
            }).catch(error => {
                //alert("ERR::" + url + "::" + error.message)
                reject(error)
            })
        });
    }
    callPostAPI(url, data) {
        const headers = this.getHeader();
        return new Promise((resolve, reject) => {
            axios.post(process.env.REACT_APP_API_URL + url, data, headers).then(response => {
                resolve(response)
            }).catch(error => {
                //alert("ERR::" + url + "::" + error.message)
                reject(error)
            })
        });
    }
    callPutAPI(url, data) {
        const headers = this.getHeader();
        return new Promise((resolve, reject) => {
            axios.put(process.env.REACT_APP_API_URL + url, data, headers).then(response => {
                resolve(response)
            }).catch(error => {
                //alert("ERR::" + url + "::" + error.message)
                reject(error)
            })
        });
    }

    validateUser() {
        const headers = this.getHeader();
        axios.get(process.env.REACT_APP_API_URL + 'membership/validate', headers).then(response => {
            if (response.status === 200 && response.data.valid) {
                return response.data.data.premiumuser === 1 ? true : false;
            } else {
                return false;
            }
        }).catch(error => {
            //alert("ERR::membership/validate::" + error.message)
            return false;
        })
    }
   


    getHeaderV2() {
        return this.buildHeaders(process.env.REACT_APP_API_KEY_V2, process.env.REACT_APP_VERSION_V2);
    }
    callGetAPIV2(url) {
        const headersV2 = this.getHeaderV2();
        return new Promise((resolve, reject) => {
            axios.get(process.env.REACT_APP_API_URL_V2 + url, headersV2).then(response => {
                resolve(response)
            }).catch(error => {
                //alert("ERR::V2::" + url + "::" + error.message)
                reject(error)
            })
        });
    }
    MailGetAPIV2(url) {
        const headersV2 = this.getHeaderV2();
        return new Promise((resolve, reject) => {
            axios.get('http://35.174.153.53/api/v1/course?page=1&limit=7', headersV2).then(response => {
                resolve(response)
            }).catch(error => {
                //alert("ERR::V2::" + url + "::" + error.message)
                reject(error)
            })
        });
    }
    callPostAPIV2(url, data) {
        const headersV2 = this.getHeaderV2();
        return new Promise((resolve, reject) => {
            axios.post(process.env.REACT_APP_API_URL_V2 + url, data, headersV2).then(response => {
                resolve(response)
            }).catch(error => {
                //alert("ERR::V2::" + url + "::" + error.message)
                reject(error)
            })
        });
    }
    callPutAPIV2(url, data) {
        const headersV2 = this.getHeaderV2();
        return new Promise((resolve, reject) => {
            axios.put(process.env.REACT_APP_API_URL_V2 + url, data, headersV2).then(response => {
                resolve(response)
            }).catch(error => {
                //alert("ERR::V2::" + url + "::" + error.message)
                reject(error)
            })
        });
    }

    validateUserV2() {
        const headersV2 = this.getHeaderV2();
        return new Promise((resolve, reject) => {
            axios.get(process.env.REACT_APP_API_URL_V2 + 'membership/validate', headersV2).then(response => {
                if (response.status === 200 && response.data.valid) {
                    return response.data.data.premiumuser === 1 ? true : false;
                } else {
                    return false;
                }
            }).catch(error => {
                //alert("ERR::V2::membership/validate::" + error.message)
                return false;
            })
        });
    }
}

export default new ApiServices();
